import AbstractAPI from '@/services/api/AbstractAPI';

export default class CountryApi extends AbstractAPI
{
    constructor(client, options) {
        super(client, options, '/countries');
    }

    fetchAll() {
        return this.makeRequest('/', 'get');
    }
}